import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/FullImage/FullImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/layouts/Grid/Grid.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Spacer/Spacer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/PageLayout/PageLayout.tsx");
